import {
  ListMultiDealRequest,
  ListMultiDealResponse
} from '@spilca/order_ts/v1/order/model_multi_deal_pb';
import { createPagination, FILTER_PARAMS } from '@monorepo/helpers';
import { Sorting } from '@spilca/order_ts/v1/order/common_pb';
import { getGrpcPromise } from '@monorepo/grpc';
import multiDealsFilterConstructor from '../multiDealsFilterConstructor';

const multiDealsRequestConstructor = (
  filter: any,
  dealService: any
): Promise<ListMultiDealResponse.AsObject> => {
  const { queryKey, pageParam, pageSize } = filter;
  const [, params] = queryKey;
  const request = new ListMultiDealRequest();

  const dealsFilter = multiDealsFilterConstructor(params, null);

  const pager = createPagination(
    pageParam || filter[FILTER_PARAMS.page] || 1,
    pageSize
  );
  const sort = new Sorting();
  sort.setFieldName('created_at');
  sort.setOrder(1);

  request.setFilter(dealsFilter);
  request.setSortingList([sort]);
  request.setPagination(pager);
  return getGrpcPromise(dealService)(request);
};

export default multiDealsRequestConstructor;
